export const updateTenantDefaultChannels = /* GraphQL */ `
  mutation UpdateTenant(
    $input: UpdateTenantInput!
    $condition: ModelTenantConditionInput
  ) {
    updateTenant(input: $input, condition: $condition) {
      id
      group
      defaultCommunicationChannels
      updatedAt
    }
  }
`;